import { BFF_URL } from "@/lib/const";
import { createApiClient } from "@/lib/http-client";

/**
 * HTTP client for the end-user self-service surface. It talks only to the BFF
 * end-user proxy (`/api/enduser/*`), which authenticates the caller with their
 * org IdP session (the `arcade_eu_session` cookie) rather than an operator
 * Better Auth session. `createApiClient` already sends `credentials: "include"`,
 * so the cookie rides along automatically.
 *
 * This intentionally does NOT use `getCoordinatorApi` / `getEngineApi`: those are
 * operator-scoped clients that require an org/project path and operator auth.
 */
export const enduserApi = createApiClient({
  baseURL: `${BFF_URL}/api/enduser`,
});
